// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vueResource from 'vue-resource'
Vue.config.productionTip = false
Vue.use(vueResource)
Vue.prototype.url = 'https://api.huofar.com/v61/7.0/'
// console.log(Vue.prototype.yijiconent)
/* eslint-disable no-new */
import wx from 'weixin-js-sdk'
new Vue({
  el: '#app',
  http: vueResource,
  router,
  template: '<App/>',
  components: { App }
})

let loveCookie = function (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(name) !== -1) return c.substring(name.length, c.length)
  }
  return ''
}
let loveId = loveCookie('hf_appId')
let loveTimestamp = loveCookie('hf_timestamp')
let loveStr = loveCookie('hf_nonceStr')
let loveSignature = loveCookie('hf_signature')
wx.config({
  debug: false,
  appId: loveId, // 和获取Ticke的必须一样------必填，公众号的唯一标识
  timestamp: loveTimestamp, // 必填，生成签名的时间戳
  nonceStr: loveStr, // 必填，生成签名的随机串
  signature: loveSignature, // 必填，签名，见附录1
  // 需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
  jsApiList: [
    'onMenuShareAppMessage', 'onMenuShareTimeline'
  ]
})

// 处理验证成功的信息
wx.ready(function () {
  let conent = Vue.prototype.yijiconent
  // console.log(conent)
  // 分享到朋友圈
  wx.onMenuShareTimeline({
    title: '今日宜忌',
    desc: conent, // 描述
    link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: 'http://img.huofar.com/images/guoriziLogo.png',
    trigger: function (res) {
      // ***
    },
    success: function (res) {

    },
    cancel: function (res) {
    },
    fail: function (res) {

    }
  })
  // 分享给朋友
  wx.onMenuShareAppMessage({
    title: '今日宜忌',
    desc: conent, // 描述
    link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: 'http://img.huofar.com/images/guoriziLogo.png',
    trigger: function (res) {
      // ***
    },
    success: function (res) {

    },
    cancel: function (res) {
    },
    fail: function (res) {

    }
  })
  wx.error(function (res) {
  })
})



// WEBPACK FOOTER //
// ./src/main.js